import axios from 'axios'

export const deliveryOccasions = ({ fromDate, toDate }) => {
    var url = `${window.MYQLOCX_API}/deliveryoccasions`
    if (fromDate && toDate) url += `?fromDate=${fromDate}&toDate=${toDate}`

    return (dispatch) => {
        dispatch({ type: 'LOADING' })
        axios.get(url).then(t => {
            dispatch({ type: 'LOADING_FINISHED' })

            dispatch({
                type: `FETCH_DELIVERYOCCASIONS_SUCCESS`,
                payload: t.data
            })
        }).catch(e => console.log(e))
    }
}

export const hotspotterQuery = (searchString, minPosition) => {
    var url = `${window.MYQLOCX_API}/subject/admin/bi/hotspotter?search=${searchString}&minposition=${minPosition}`

    return axios.get(url)
}

export const getSesamRequests = () => {
    const url = `${window.MYQLOCX_API}/subject/admin/bi/sesam/requests`

    return (dispatch) => {
        axios.get(url).then(t => {
            dispatch({
                type: 'FETCH_SESAMREQUESTS_SUCCESS',
                payload: t.data
            })
        }).catch(e => {
            console.log(e)
        })
    }
}

export const getSesamLockDescriptions = () => {
    const url = `${window.MYQLOCX_API}/subject/admin/bi/sesam/lockdescriptions`

    return (dispatch) => {
        axios.get(url).then(t => {
            dispatch({
                type: 'FETCH_SESAMLOCKDESCRIPTIONS_SUCCESS',
                payload: t.data
            })
        }).catch(e => {
            console.log(e)
        })
    }
}

export const getSesamThread = threadId => {
    var url = `${window.MYQLOCX_API}/subject/admin/bi/sesam/thread?id=${threadId}`

    return dispatch => {
        axios.get(url).then(t => {
            dispatch({
                type: 'FETCH_SESAMTHREAD_SUCCESS',
                payload: t.data
            })
        }).catch(e => {
            console.log(e)
        })
    }
}

export const getSesamThreads = () => {
    var url = `${window.MYQLOCX_API}/subject/admin/bi/sesam/threads`

    return dispatch => {
        axios.get(url).then(t => {
            dispatch({
                type: 'FETCH_SESAMTHREADS_SUCCESS',
                payload: t.data
            })
        }).catch(e => {
            console.log(e)
        })
    }
}

export const saveAltAddresses = (addresses, lockId) => (dispatch) => {
    dispatch({ type: 'SAVE_ALT_ADDRESSES_REQUEST' })
    axios.post(`${window.MYQLOCX_API}/subject/admin/bi/${lockId}/alternative-addresses`, { addresses, lockId }).then(() => {
        dispatch({ type: 'SAVE_ALT_ADDRESSES_SUCCESS', payload: { addresses, lockId } })
    }).catch((error) => {
        dispatch({ type: 'SAVE_ALT_ADDRESSES_FAIL', error })
        console.error(error)
    })
}

export const saveGateAddresses = (addresses, lockId) => (dispatch) => {
    dispatch({ type: 'SAVE_GATE_ADDRESSES_REQUEST' })
    axios.post(`${window.MYQLOCX_API}/subject/admin/bi/${lockId}/gate-addresses`, { addresses, lockId }).then(() => {
        dispatch({ type: 'SAVE_GATE_ADDRESSES_SUCCESS', payload: { addresses, lockId } })
    }).catch((error) => {
        dispatch({ type: 'SAVE_GATE_ADDRESSES_FAIL', error })
        console.error(error)
    })
}

export const createDeliveries = (deliveries) => (dispatch) => {
    const { userType } = localStorage

    dispatch({ type: 'CREATE_DELIVERY_REQUEST' })
    return axios.post(`${window.MYQLOCX_API}/subject/${userType === 'admin' ? 'admin/bi/createdeliveries' : userType + '/deliveries'}`, deliveries)
        .then(() => {
            dispatch({ type: 'CREATE_DELIVERY_SUCCESS' })
        })
        .catch((e) => {
            dispatch({ type: 'CREATE_DELIVERY_FAIL' })
        })
}

export function createDeliveriesRerun(deliveries) {
    return (dispatch) => {
        dispatch({ type: 'CREATE_DELIVERY_REQUEST' })
        return axios
            .post(`${window.MYQLOCX_API}/subject/admin/bi/createdeliveries/rerun`, deliveries)
            .then((r) => {
                dispatch({ type: 'DELIVERY_CREATED' })
                return r
            })
            .catch(() => dispatch({ type: 'DELIVERY_CREATED_FAIL' }))
    }
}

export const sendDeliveriesStatus = (deliveries) => (dispatch) => {
    dispatch({ type: 'FINISH_DELIVERIES_REQUEST' })
    return axios
        .put(`${window.MYQLOCX_API}/subject/admin/bi/finishdeliveries`, deliveries)
        .then((r) => {
            dispatch({ type: 'DELIVERIES_FINISHED' })
            return r
        })
        .catch(() => dispatch({ type: 'DELIVERIES_FINISHED_FAIL' }))
}